/*=== Javascript function indexing hear===========
01. detectSystemMode()
02. headerSticky()
03. searchToggle()
04. themeMode()
05. swiperActivation()
06. wowActive()
07. videoActivation()
08. backToTopInit()
09. magnificPopup()
10. mobileMenu()
11. stickySidebar()
12. preloader()
13. svgInject()
14. comingSoon()
15. postFormat()
16. modalPopup()
17. cookiePopup()


==================================================*/
(function ($) {
    'use strict';
   
    var rtsJs = {
      m: function (e) {
        rtsJs.d();
        rtsJs.methods();
      },
      d: function (e) {
          this._window = $(window),
          this._document = $(document),
          this._body = $('body'),
          this._html = $('html')
      },
      methods: function (e) {
        rtsJs.detectSystemMode();
        rtsJs.headerSticky();
        rtsJs.searchToggle();
        rtsJs.themeMode();
        rtsJs.swiperActivation();
        rtsJs.wowActive();
        rtsJs.videoActivation();
        rtsJs.backToTopInit();
        rtsJs.magnificPopup();
        rtsJs.mobileMenu();
        rtsJs.stickySidebar();
        rtsJs.preloader();
        rtsJs.svgInject();
        rtsJs.comingSoon();
        rtsJs.postFormat();
        rtsJs.modalPopup();
        rtsJs.cookiePopup();
      },
      // Detect System Theme Mode
      detectSystemMode: function () {
        // Function to set the theme based on system preference
        function setThemeBasedOnPreference() {
          const theme = window.matchMedia("(prefers-color-scheme: dark)").matches ? "dark" : "light";
          document.documentElement.setAttribute("data-theme", theme);
        }
        // Initial setting of the theme
        setThemeBasedOnPreference();
        // Add an event listener to detect changes in the color scheme preference
        window.matchMedia("(prefers-color-scheme: dark)").addEventListener("change", setThemeBasedOnPreference);

      },
       // sticky Header
      headerSticky: function () {
        let logoSelector = $('.lumne__logo');
        $(window).on("scroll", function() {
          var ScrollBarPostion = $(window).scrollTop();
          if (ScrollBarPostion > 100) {
            $(".header__function").addClass("is__sticky");  
            logoSelector.addClass("is__active")    
          } else {
            $(".header__function").removeClass("is__sticky");
            logoSelector.removeClass("is__active")   
          }
        });
      },
      searchToggle: function(){
        $(document).ready(function() {
          $(".search__switcher").on("click", function() {
              $(".lumne__search").toggleClass("show");
          });
          $(".lumne__close").on("click", function() {
              $(".lumne__search").removeClass("show");
          });
          $(document).on("click", function(event) {
              if (!$(event.target).closest(".lumne__search, .search__switcher").length) {
                  $(".lumne__search").removeClass("show");
              }
          });
          // notification switcher
          $(".notification__switcher").on("click", function() {
              $(".lumne__notification").toggleClass("show");
          });
          $(".lumne__close").on("click", function() {
              $(".lumne__notification").removeClass("show");
          });
          $(document).on("click", function(event) {
              if (!$(event.target).closest(".lumne__notification, .notification__switcher").length) {
                  $(".lumne__notification").removeClass("show");
              }
          });
      });
      
      },
      themeMode: function(){
        $(document).ready(function(){
          const rtsLight = $('.mod__switcher');
          if (rtsLight.length) {
              const toggle = document.getElementById("theme__mode");
              const prefersDarkScheme = window.matchMedia("(prefers-color-scheme: dark)").matches;
              const storedTheme = localStorage.getItem('lumne-theme') || (prefersDarkScheme ? "dark" : "light");
              if (storedTheme) {
                  document.documentElement.setAttribute('data-theme', storedTheme);
              }

              toggle.onclick = function() {
                  const currentTheme = document.documentElement.getAttribute("data-theme");
                  const targetTheme = currentTheme === "light" ? "dark" : "light";
                  document.documentElement.setAttribute('data-theme', targetTheme);
                  localStorage.setItem('lumne-theme', targetTheme);
              };
          }

        });
      },
      swiperActivation: function(){
      $(document).ready(function(){
        var businessHero = new Swiper(".business__slider", {
          slidesPerView: 1,
          loop: true,
          effect: "fade",
          navigation: {
            nextEl: ".lumne-button-next",
            prevEl: ".lumne-button-prev",
          },
        });
         //  trending post slider
        var trendingPost = new Swiper(".trending__post__slider", {
          slidesPerView: 4,
          spaceBetween: 30,
          loop: true,
          autoplay: {
            delay: 2000,
            disableOnInteraction: false,
          },
          pagination: {
            el: ".lumne__dots",
            clickable: true,
          },
          breakpoints: {
            0: {
              slidesPerView: 1,
            },
            576: {
              slidesPerView: 1.2,
            },
            768: {
              slidesPerView: 2,
            },
            992: {
              slidesPerView: 2.2,
            },
            1200: {
              slidesPerView: 2.8,
            },
            1400: {
              slidesPerView: 3,
            },
            1600: {
              slidesPerView: 4,
            },
          }
        });
        // header latest post slider
        new Swiper(".latest__post__slider", {
          slidesPerView: 1,
          direction: "vertical",
          loop: true,
          autoplay: {
            delay: 2000,
            disableOnInteraction: false,
          },
        });
        // Life style slider
        var bgSlider = new Swiper(".bg__slider", {
          slidesPerView: 1,
          loop: true,
          effect: "fade",
          navigation: {
            nextEl: ".lumne-button-next",
            prevEl: ".lumne-button-prev",
          },
        });
        var lifeText = new Swiper(".life__text__slider", {
          slidesPerView: 1,
          loop: true,
          effect: "slide",
          navigation: {
            nextEl: ".lumne-button-next",
            prevEl: ".lumne-button-prev",
          },
        })
        try {
          $(document).ready(function () {
            const $canvas = $("#background-canvas");
            const canvas = $canvas[0];
          
            if (!canvas || !(canvas instanceof HTMLCanvasElement)) {
              console.log("Canvas element only work Reel Style Post Slider");
              return;
            }
          
            const ctx = canvas.getContext("2d");
            canvas.width = 5;
            canvas.height = 5;
          
            // Initialize Swiper instance
            const story = new Swiper(".lumne__story__card", {
              slidesPerView: 1,
              loop: true,
              autoplay: {
                delay: 5000,
                disableOnInteraction: false,
              },
              navigation: {
                nextEl: ".lumne__next",
                prevEl: ".lumne__prev",
              },
              on: {
                slideChangeTransitionEnd: updateCanvasWithImage,   // Changed to ensure the slide transition is complete
              },
            });
          
            function updateCanvasWithImage() {
              const $currentSlideImage = $(".swiper-slide-active .slide-image");
              if ($currentSlideImage.length) {
                if ($currentSlideImage[0].complete) {
                  drawImageOnCanvas($currentSlideImage[0]);
                } else {
                  $currentSlideImage.one("load", function () {
                    drawImageOnCanvas(this);
                  });
                }
              }
            }
          
            function drawImageOnCanvas(image) {
              // Clear the canvas before drawing the new image
              ctx.clearRect(0, 0, canvas.width, canvas.height);
              ctx.drawImage(image, 0, 0, canvas.width, canvas.height);
            }
          
            // Initial canvas update
            updateCanvasWithImage();
          });
        } catch (error) {
          console.log('This is not a canvas element');
        }
        
      });
      },  
      wowActive: function () {
        new WOW().init();
      },

      videoActivation: function (e) {
        $(document).ready(function() {
          $('.popup-youtube, .popup-vimeo, .popup-gmaps, .video-play').magnificPopup({
            disableOn: 700,
            type: 'iframe',
            mainClass: 'mfp-fade',
            removalDelay: 160,
            preloader: false,
            fixedContentPos: false
          });
        });
      },

      backToTopInit: function (e) {
        $(document).ready(function () {
          var backButton = $("#rts-back-to-top");
          $(window).scroll(function () {
            if ($(this).scrollTop() > 100) {
              backButton.addClass("show");
            } else {
              backButton.removeClass("show");
            }
          });
          backButton.on("click", function () {
            $("html, body").animate(
              {
                scrollTop: 0,
              },
              1000
            );
          });
        });
      },
      magnificPopup: function (e) {
        $('.gallery').each(function() { 
          $(this).magnificPopup({
              delegate: '.image-popup', 
              type: 'image',
              gallery: {
                enabled:true
              }
          });
      });
      },
      mobileMenu: function (e) {
        try {
          var mainMenuClone = $('.navigation__menu > ul').clone();
          var lumneMenu = $('.rts__mobile__menu nav'); // Mobile menu container
          lumneMenu.append(mainMenuClone);
          // Add toggle buttons for items with submenus and mega menus
          lumneMenu.find('.has-child, .mega__menu').each(function() {
              $(this).append('<button class="tp-menu-close"><img src="assets/img/icon/menu-chevron-down.svg" class="svginject" alt=""></button>');
          });

          // Toggle submenus on button click
          var sideMenuList = $('.rts__mobile__menu nav > ul > li button.tp-menu-close, .rts__mobile__menu nav > ul li.has-child > a');
          sideMenuList.on('click', function(e) {
              e.preventDefault();
              var parent = $(this).parent();
              if (!parent.hasClass('active')) {
                  // Expand the submenu
                  parent.addClass('active');
                  parent.find('.submenu, .has__mega__menu').first().slideDown();
              } else {
                  // Collapse the submenu
                  parent.removeClass('active');
                  parent.find('.submenu, .has__mega__menu').first().slideUp();
              }
          });

        } catch (error) {
          console.log(error);
        }
      },
      stickySidebar: function (e) {
        if (typeof $.fn.theiaStickySidebar !== "undefined") {
          $(".sticky-wrap .sticky-item").theiaStickySidebar({
            additionalMarginTop: 100,
          });
        }
      },
      preloader: function (e){
        window.addEventListener('load',function(){
          document.querySelector('body').classList.add("loaded")  
        });     
      },

      svgInject: function (e) {
        SVGInject(document.querySelectorAll(".svginject"));
      },
      comingSoon: function (e) {
        $(document).ready(function() {
          // Ensure the flipdown element exists in the DOM
          const $flipdownElement = $('.flipdown');
          
          if (!$flipdownElement.length) {
            return; // Exit the function early if the element doesn't exist
          }
          
          // Set the target date and time for the countdown (target: Dec 31, 2024, 23:59:59)
          var targetDate = new Date("Dec 31, 2024 23:59:59").getTime() / 1000;  // Get timestamp in seconds
        
          // Initialize the FlipDown countdown
          var flipdown = new FlipDown(targetDate, $flipdownElement[0])
            .start()
            .ifEnded(() => {
              // When the countdown ends, update the message
              $flipdownElement.html('<h2>Timer is ended</h2>');
            });
        });        
      },
      postFormat: function (e) {
        $(document).ready(function () {
          new Swiper(".post__format__gallery", {
            slidesPerView: 1,
            loop: true,
            autoplay: {
              delay: 5000,
              disableOnInteraction: false,
            },
            navigation: {
              nextEl: ".lumne-button-next",
              prevEl: ".lumne-button-prev",
            },
          })
        });        
      },
      modalPopup: function (e) {
        $(document).ready(function () {
          var modalShown = localStorage.getItem('modalShown');
          function showModal() {
            if (!modalShown && window.innerWidth > 575) {
              setTimeout(function () {
                $("#sub-form").modal('show');
                localStorage.setItem('modalShown', 'true');
              }, 2000); 
            }
          }
          showModal();
        });
        
      },
      cookiePopup: function (e) {
        $.gdprcookie.init();
      }
    }
    rtsJs.m();   
  })(jQuery, window)